import { requiredNullish } from '@breezeventures/web-ph-validators/zod-utils';
import { z } from 'zod';

import { documentSchema } from './document-schema';

import { idDocumentValidators } from '../id-document-validators';
import { idDocumentTypeValues } from '../person';

export const idDocumentSchema = z
  .object({
    type: requiredNullish(z.enum(idDocumentTypeValues)),
    document: requiredNullish(documentSchema, 'Photo of your ID is required'),
    idNumber: z.string().trim().min(1, 'Enter document number'),
  })
  .superRefine((data, ctx) => {
    const idNumber = data.idNumber?.trim();
    if (data.type && idNumber) {
      const validators = idDocumentValidators[data.type];
      if (validators && !validators.pattern.value.test(idNumber)) {
        ctx.addIssue({
          code: 'custom',
          path: ['idNumber'],
          message: validators.pattern.message,
        });
      }
    }
  });

export type IdDocumentFormValues = z.infer<typeof idDocumentSchema>;
